import classNames from 'classnames';
import * as React from 'react';

import * as styles from '../index.css';

export interface IErrorProps {
  error: string | null;
}

export const Error = ({ error }: IErrorProps) => <div className={classNames(styles['error'])}>{error}</div>;
